import type {
	ICellValue,
	InternalState,
	IPercentField,
	IPercentFieldProperty,
} from '../types'

import z from 'zod'

import { getFieldDefaultProperty } from '../constants'
import { str2number } from '../convert'
import { numberToShow, times } from '../number'
import { FieldType } from '../types'
import { NumberBaseField } from './number-base-field'

export class PercentField extends NumberBaseField {
	constructor(
		public override field: IPercentField,
		public override state: InternalState
	) {
		super(field, state)
	}

	static readonly propertySchema = z.object({
		precision: z.number().min(0).max(10),
		defaultValue: z.string().optional(),
	})

	// preview state data
	override cellValueToString(cellValue: ICellValue): string | null {
		if (this.validate(cellValue)) {
			const cellString = numberToShow(
				times(cellValue, 100),
				this.field.property.precision
			)

			return cellString == null ? null : `${cellString}%`
		}

		return null
	}

	// Return the default value of the field attribute configuration when adding a record
	override defaultValue(): ICellValue {
		const { defaultValue } = this.field.property

		return defaultValue ? str2number(defaultValue) : null
	}

	compareCellValue(cellValue: ICellValue): number | null {
		const cellValue2Str = this.cellValueToString(cellValue)

		return cellValue2Str === null ? null : str2number(cellValue2Str as string)
	}
	validateProperty() {
		return PercentField.propertySchema.safeParse(this.field.property)
	}

	static defaultProperty(): IPercentFieldProperty {
		return getFieldDefaultProperty(FieldType.Percent) as IPercentFieldProperty
	}
}
